// PollutantsDialog.js
import { useState } from "react"
import { Typography } from '@mui/material'
import PollutantsForm from './PollutantsForm'
import "../../css/DemoCode.css"

/**
 * Frame for data inputs. 
 * 
 * @param {JSON} model A SWMM model in JSON format. In most cases this
 * is a 'submodel' containing only a copy of the affected sections. Using a copy allows
 * for continuous react-style editing without forcing the model to run on every keystroke.
 * @param {function} setModel Update function for updating 'model'.
 * @param {string} targetType The name of the SWMM inp section targetted by this form.
 * @param {string} subkeysSection The name of the SWMM inp subsection targetted by this form.
 * @param {string} target The name of the object targetted by this form.
 * @param {function} setNewName Sets the new name of this object if the user modifies the name.
 * @param {JSON} fullModel The 'full' SWMM model that contains supporting data for this component.
 * @param {function} setFullModel Sets the full model in case of any updates.
 * @returns UI for interactive swmm modeling.
 */
export default function PollutantsDialog({ model, setModel, targetType, subkeysSection, target, setNewName, fullModel, setFullModel }) {
  const [newTargetName, setNewTargetName] = useState(target)

  const saveEdits = () => {
    setFullModel(prev => ({
      ...prev, 
      POLLUTANTS: {
        ...prev.POLLUTANTS, 
        [target]: model.POLLUTANTS[target]
      }
    }))
  }

  function handleChange(e) {
    setNewName(e.target.value)
    setNewTargetName(e.target.value)
  }

  /**
   * If there is a valid model, create a UI for the model.
   */
  if(model){
    return(
      <>
      {
        <>
          <Typography id="modal-modal-title" variant="p4" >
            <div style={{display:"flex", flexDirection: "column", padding: '10px'}}>
              <label>Pollutant Name</label>
              <input style={{fontSize: '16px', background: 'rgb(50, 50, 50)', color: 'lightskyblue', border: 'none', textAlign: 'center'}} type="text" value={newTargetName} onChange={handleChange} />
            </div>
          </Typography>
            
            {
              targetType && 
              targetType in model && 
              target &&
              (
                <>
                  <PollutantsForm model={model} setModel={setModel} fullModel={fullModel} target={target} targetType={'POLLUTANTS'} subkeysSection={subkeysSection} saveEdits={saveEdits} />
                </>
              )
            }
          </>
        }
      </>
    )
  } else {
    return null
  }
}